import React, {Component} from 'react';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {baseTokenSymbol, reactTableText} from '../../constants/configs';
import {numberWithCommas} from "../../helpers/Utils";

class Balances extends Component {
  getColumns = t => [
    {
      Header: t('Gateway'),
      accessor: 'terminal.name',
    },
    {
      Header: `${t('Amount')} (${t(baseTokenSymbol)})`,
      accessor: 'amount',
      Cell: props => {
        return (
          <span>{numberWithCommas(Number(props.value))}</span>
        );
      }
    },
  ];

  render() {
    const {t, data, loading} = this.props;
    return (
      <ReactTable
        manual
        data={data}
        loading={loading}
        ref={el => {this.table = el;}}
        className="-highlight"
        columns={this.getColumns(t)}
        pageSize={data.length || 10}
        showPagination={false}
        sortable={false}
        resizable={true}
        style={{
          width: '100%',
          marginTop: 20,
          marginBottom: 10,
        }}
        {...reactTableText}
      />
    );
  }
}

export default withTranslation()(Balances);
